import { Login, Logout } from "./../models";
import axiosClient from "./axiosClient";

const loginApi = {
  verifyOtp(data: Login): Promise<Login> {
    const url = `users/superAdminLogin`;
    return axiosClient.post(url, data.payload);
  },
  getResendOtp(data: Login): Promise<Login> {
    const url = `users/resendOTP`;
    return axiosClient.post(url, data.payload);
  },
  userLogout(data: Logout): Promise<Logout> {
    const url = `users/superAdminLogout`;
    return axiosClient.post(url, data.payload);
  },
};

export default loginApi;
